import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { PaymentType } from '../payment-account/enums/payment-types.enum';

@Component({
  selector: 'gtd-payment-fields',
  templateUrl: './payment-fields.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PaymentFieldsComponent),
    },
  ],
})
@DestroySubscribers()
export class PaymentFieldsComponent implements ControlValueAccessor, OnInit {
  constructor(private cd: ChangeDetectorRef) {}
  public control: UntypedFormControl;
  public dependControl: UntypedFormControl;
  public value: string;
  public subscribers: Record<string, Subscription> = {};
  public paymentTypes = PaymentType;
  public currentPaymentType: string;
  public paymentMethods: string[];
  public formGroup = new UntypedFormGroup({
    [PaymentType['Wire Transfer']]: new UntypedFormGroup({
      'Beneficiary name': new UntypedFormControl(null, Validators.required),
      'Beneficiary address': new UntypedFormControl(null, Validators.required),
      Bank: new UntypedFormControl(null, Validators.required),
      'Bank Address': new UntypedFormControl(null, Validators.required),
      'Bank Country': new UntypedFormControl(null, Validators.required),
      Swift: new UntypedFormControl(null, Validators.required),
      IBAN: new UntypedFormControl(null, Validators.required),
      'REG number': new UntypedFormControl(null, Validators.required),
      'Owner / Director name': new UntypedFormControl(null, Validators.required),
    }),
  });

  public onChange: (value: { [key: string]: { [key: string]: string } }) => void = () => {};
  public onTouch = () => {};

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(value: string): void {
    this.value = value;
    if (value) {
      if (this.currentPaymentType) {
        const currentValues: Record<string, string> = this.value[this.currentPaymentType];
        const formGroup = this.formGroup.controls[this.currentPaymentType] as UntypedFormGroup;
        for (const formKey in currentValues) {
          if (formKey in currentValues) {
            const formValue = currentValues[formKey];
            const formControl: AbstractControl = formGroup?.controls[formKey];
            if (formControl) {
              formControl.patchValue(formValue);
            }
          }
        }
      }
    }
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.subscribers.dependControl = this.dependControl.valueChanges.subscribe((type: string) => {
      if (!this.dependControl.value || this.dependControl.value === '0') {
        this.dependControl.setValue(this.paymentMethods[0]);
        this.currentPaymentType = this.dependControl.value;
      } else {
        this.currentPaymentType = type;
      }
      this.formGroup.updateValueAndValidity();
      this.cd.detectChanges();
    });
    this.subscribers.formGroup = this.formGroup.valueChanges
      .pipe(map((value) => ({ [this.currentPaymentType]: value[this.currentPaymentType] })))
      .subscribe((value) => {
        this.onChange(value);
        this.onTouch();
      });
    const validator = () => {
      const err = { required: true };
      const selectedGroup = this.formGroup.get(this.currentPaymentType);
      if (!selectedGroup) return null;
      if (selectedGroup.invalid) return err;
      return null;
    };
    this.control.setValidators(validator);
  }
}
